import { render, staticRenderFns } from "./yc.vue?vue&type=template&id=650f6b6c&scoped=true&"
import script from "./yc.vue?vue&type=script&lang=js&"
export * from "./yc.vue?vue&type=script&lang=js&"
import style0 from "./yc.vue?vue&type=style&index=0&id=650f6b6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f6b6c",
  null
  
)

export default component.exports